import React from 'react';
import { Image, Container } from 'react-bootstrap';
import {Link } from 'react-router-dom';
import logo from '../assets/images/l.png';
import { FaLinkedin, FaGithub, FaWhatsapp } from 'react-icons/fa';
import { getContactInfo } from '../data/contactData';

function Footer() {
    const contactInfo = getContactInfo();

    return (
        <footer className="footer-wrapper">
            <Container className="footer-content d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center flex-wrap px-5">
                <div className="footer-logo-container d-flex justify-content-center align-items-center flex-wrap mb-2 mb-lg-0">
                    <Link to="/">
                        <Image src={logo} alt="Logo" className="footer-logo m-0 me-2" />
                    </Link>
                    <p className="footer-text m-0 text-center text-lg-start">
                        {new Date().getFullYear()} Designed & Built by <span>Doaa Ali</span>
                    </p>
                </div>
                <div className="footer-links d-flex justify-content-center align-items-center flex-wrap">
                    <a href={contactInfo?.linkedin} target="_blank" rel="noopener noreferrer" className="mx-2">
                        <FaLinkedin />
                    </a>
                    <a href={contactInfo?.github} target="_blank" rel="noopener noreferrer" className="mx-2">
                        <FaGithub />
                    </a>
                    <a href={contactInfo?.whatsapp} target="_blank" rel="noopener noreferrer" className="mx-2">
                        <FaWhatsapp />
                    </a>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;
